import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/features/auth/hooks/useAuth'
import { BootScreen } from '@/shared/components/ui/BootScreen'
import { getDashboardPathForRole } from '@/shared/constants/roles'

export function PublicOnlyRoute() {
  const { isAuthenticated, isBootstrapping, role } = useAuth()

  if (isBootstrapping) {
    return <BootScreen />
  }

  if (isAuthenticated && role) {
    return <Navigate to={getDashboardPathForRole(role)} replace />
  }

  return <Outlet />
}
